import { userSessionTypes } from 'shared/constants';
import { isValidObject, isValidArrayLength } from 'shared/helpers';
import { MenuItemOverride, MenuItems } from 'shared/types/Header';
import { menuItems } from 'shared/constants/kebabMenu';

const { GUEST, LOGGED_IN } = userSessionTypes;

export const getMenuItems = (overrides?: MenuItemOverride): MenuItems => {
  const updatedMenuItems = menuItems[__PLATFORM__];
  if (
    isValidObject(overrides as object) &&
    isValidArrayLength(Object.keys(overrides as object))
  ) {
    const updatedGuestItems = updatedMenuItems[GUEST]?.map((item) => ({
      ...item,
      ...(overrides && overrides[item.displayText]),
    }));
    const updatedLoggedInItems = updatedMenuItems[LOGGED_IN]?.map((item) => ({
      ...item,
      ...(overrides && overrides[item.displayText]),
    }));
    return {
      [GUEST]: updatedGuestItems,
      [LOGGED_IN]: updatedLoggedInItems,
    };
  }
  return updatedMenuItems;
};
